import { Select, SelectProps, useMantineTheme } from "@mantine/core";
import { ArrowDown2 } from "iconsax-react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface IProps extends SelectProps {
  name: string;
}
export default function SelectControlled({ name, ...props }: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Select
          styles={{ rightSection: { pointerEvents: "none" } }}
          aria-label="select"
          dropdownPosition="bottom"
          rightSection={<ArrowDown2 size="24" color={theme.colors.basic[5]} />}
          error={!!error?.message ? t(error.message) : ""}
          {...field}
          {...props}
        />
      )}
    />
  );
}
